import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';

// Clean outline icons (Heroicons/Phosphor style)
const Icon = ({ name, size = 20, style = {} }) => {
  const icons = {
    dashboard: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7"/>
        <rect x="14" y="3" width="7" height="7"/>
        <rect x="14" y="14" width="7" height="7"/>
        <rect x="3" y="14" width="7" height="7"/>
      </svg>
    ),
    orders: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
      </svg>
    ),
    cart: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
      </svg>
    ),
    wishlist: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
    addresses: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    profile: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
        <circle cx="12" cy="7" r="4"/>
      </svg>
    ),
    support: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12l2 2 4-4"/>
        <path d="M21 12c.552 0 1-.448 1-1V5c0-.552-.448-1-1-1H3c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h18z"/>
        <path d="M3 12v6c0 .552.448 1 1 1h16c.552 0 1-.448 1-1v-6"/>
      </svg>
    ),
    store: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9,22 9,12 15,12 15,22"/>
      </svg>
    ),
    logout: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
        <polyline points="16,17 21,12 16,7"/>
        <line x1="21" y1="12" x2="9" y2="12"/>
      </svg>
    ),
    chevron: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9,18 15,12 9,6"/>
      </svg>
    ),
    bell: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    ),
    calendar: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
        <line x1="16" y1="2" x2="16" y2="6"/>
        <line x1="8" y1="2" x2="8" y2="6"/>
        <line x1="3" y1="10" x2="21" y2="10"/>
      </svg>
    ),
    download: (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7,10 12,15 17,10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
    )
  };

  return icons[name] || null;
};

const NavLink = ({ to, icon, children, active, external = false, onClick }) => (
  <Link
    to={to}
    target={external ? '_blank' : undefined}
    rel={external ? 'noopener noreferrer' : undefined}
    onClick={onClick}
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '10px 16px',
      textDecoration: 'none',
      fontSize: '14px',
      fontWeight: active ? '600' : '500',
      color: active ? '#0D7463' : '#6B6B6B',
      backgroundColor: active ? '#F0FDF4' : 'white',
      transition: 'all 150ms ease',
      borderRadius: '6px',
      margin: '2px 8px'
    }}
    onMouseEnter={(e) => {
      if (!active) {
        e.target.style.backgroundColor = '#F3F4F6';
        e.target.style.color = '#374151';
      }
    }}
    onMouseLeave={(e) => {
      if (!active) {
        e.target.style.backgroundColor = 'white';
        e.target.style.color = '#6B6B6B';
      }
    }}
  >
    <Icon name={icon} size={20} style={{ color: active ? '#059669' : '#6B7280' }} />
    <span>{children}</span>
    {external && (
      <Icon name="external" size={12} style={{ marginLeft: 'auto', opacity: 0.6 }} />
    )}
  </Link>
);

const SectionHeader = ({ children }) => (
  <div style={{
    padding: '8px 16px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#9CA3AF',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginTop: '16px'
  }}>
    {children}
  </div>
);

export default function CustomerShell({ children }) {
  const { customer, logout } = useCustomerAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  
  const isActive = (path) => location.pathname === path;

  // Fetch notifications
  useEffect(() => {
    const fetchNotifications = async () => {
      if (!customer) {
        console.log('CustomerShell: No customer data, skipping notification fetch');
        return;
      }
      
      console.log('CustomerShell: Fetching notifications for customer:', customer._id);
      
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || '/api'}/customer/dashboard/notifications`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          console.log('CustomerShell: Notifications fetched:', data);
          setNotifications(data.notifications || []);
          setUnreadCount(data.notifications?.filter(n => !n.isRead).length || 0);
        } else {
          console.error('CustomerShell: Failed to fetch notifications:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('CustomerShell: Failed to fetch notifications:', error);
      }
    };

    fetchNotifications();
  }, [customer]);

  const handleLogout = () => {
    logout();
  };


  return (
    <div style={{ 
      display: 'flex',
      minHeight: '100vh', 
      backgroundColor: '#FFFFFF'
    }}>
      {/* Sidebar */}
      <aside style={{
        backgroundColor: '#FFFFFF',
        borderRight: '1px solid #E5E7EB',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '250px',
        flexShrink: 0,
        overflowY: 'auto',
        position: 'sticky',
        top: 0,
        zIndex: 10
      }}>
        {/* Logo */}
        <div style={{ 
          padding: '20px 16px',
          borderBottom: '1px solid #E5E7EB'
        }}>
          <div style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#111827',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <div style={{
              width: '32px',
              height: '32px',
              backgroundColor: '#0D7463',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
              fontWeight: '700'
            }}>
              C
            </div>
            Customer Portal
          </div>
        </div>

        {/* User Info */}
        <div style={{
          padding: '16px',
          borderBottom: '1px solid #E5E7EB',
          backgroundColor: '#F9FAFB'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              backgroundColor: '#0D7463',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600'
            }}>
              {customer?.firstName?.charAt(0) || 'U'}
            </div>
            <div>
              <div style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#111827'
              }}>
                {customer?.firstName} {customer?.lastName}
              </div>
              <div style={{
                fontSize: '12px',
                color: '#6B7280'
              }}>
                {customer?.email}
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav style={{ 
          flex: 1, 
          padding: '8px 0',
          overflowY: 'auto'
        }}>
          {/* Main Navigation */}
          <NavLink 
            to="/customer/dashboard" 
            icon="dashboard" 
            active={isActive('/customer/dashboard')}
          >
            Dashboard
          </NavLink>

          <NavLink
            to="/customer/dashboard/orders"
            icon="orders"
            active={isActive('/customer/dashboard/orders')}
          >
            My Orders
          </NavLink>

          <NavLink
            to="/customer/dashboard/appointments"
            icon="calendar"
            active={isActive('/customer/dashboard/appointments')}
          >
            Appointments
          </NavLink>

          <NavLink
            to="/customer/dashboard/cart"
            icon="cart"
            active={isActive('/customer/dashboard/cart')}
          >
            Shopping Cart
          </NavLink>

          <NavLink
            to="/customer/dashboard/wishlist"
            icon="wishlist"
            active={isActive('/customer/dashboard/wishlist')}
          >
            Wishlist
          </NavLink>

          <NavLink
            to="/customer/dashboard/downloads"
            icon="download"
            active={isActive('/customer/dashboard/downloads')}
          >
            Digital Library
          </NavLink>

          <SectionHeader>Account</SectionHeader>

          <NavLink 
            to="/customer/dashboard/addresses" 
            icon="addresses" 
            active={isActive('/customer/dashboard/addresses')}
          >
            Addresses
          </NavLink>

          <NavLink 
            to="/customer/dashboard/profile" 
            icon="profile" 
            active={isActive('/customer/dashboard/profile')}
          >
            Profile Settings
          </NavLink>

          <NavLink 
            to="/customer/dashboard/notifications" 
            icon="bell" 
            active={isActive('/customer/dashboard/notifications')}
          >
            Notifications
            {unreadCount > 0 && (
              <span style={{
                backgroundColor: '#EF4444',
                color: 'white',
                fontSize: '10px',
                fontWeight: '600',
                minWidth: '16px',
                height: '16px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 4px',
                marginLeft: 'auto'
              }}>
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </NavLink>

          <NavLink 
            to="/customer/dashboard/support" 
            icon="support" 
            active={isActive('/customer/dashboard/support')}
          >
            Support
          </NavLink>

        </nav>

        {/* Logout Button */}
        <div style={{
          padding: '16px',
          borderTop: '1px solid #E5E7EB'
        }}>
          <button
            onClick={handleLogout}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '10px 16px',
              width: '100%',
              backgroundColor: 'transparent',
              border: '1px solid #E5E7EB',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#6B7280',
              cursor: 'pointer',
              transition: 'all 150ms ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#FEF2F2';
              e.target.style.borderColor = '#FECACA';
              e.target.style.color = '#DC2626';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.borderColor = '#E5E7EB';
              e.target.style.color = '#6B7280';
            }}
          >
            <Icon name="logout" size={20} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#F9FAFB'
      }}>
        {/* Top Bar */}
        <header style={{
          backgroundColor: '#FFFFFF',
          borderBottom: '1px solid #E5E7EB',
          padding: '16px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div>
            <h1 style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#111827',
              margin: 0
            }}>
              My Account
            </h1>
            <p style={{
              fontSize: '14px',
              color: '#6B7280',
              margin: '4px 0 0 0'
            }}>
              Manage your orders, profile, and preferences
            </p>
          </div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            {/* Notification Bell */}
            <Link
              to="/customer/dashboard/notifications"
              style={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                backgroundColor: '#F9FAFB',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                textDecoration: 'none',
                color: '#6B7280',
                transition: 'all 150ms ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#F3F4F6';
                e.target.style.borderColor = '#D1D5DB';
                e.target.style.color = '#374151';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#F9FAFB';
                e.target.style.borderColor = '#E5E7EB';
                e.target.style.color = '#6B7280';
              }}
            >
              <Icon name="bell" size={20} />
              {unreadCount > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '-2px',
                  right: '-2px',
                  backgroundColor: '#EF4444',
                  color: 'white',
                  fontSize: '10px',
                  fontWeight: '600',
                  minWidth: '18px',
                  height: '18px',
                  borderRadius: '9px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 4px'
                }}>
                  {unreadCount > 99 ? '99+' : unreadCount}
                </div>
              )}
            </Link>
            
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              backgroundColor: '#F0FDF4',
              borderRadius: '6px',
              border: '1px solid #BBF7D0'
            }}>
              <div style={{
                width: '8px',
                height: '8px',
                backgroundColor: '#22C55E',
                borderRadius: '50%'
              }}></div>
              <span style={{
                fontSize: '12px',
                fontWeight: '500',
                color: '#166534'
              }}>
                Authenticated
              </span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <div style={{
          flex: 1,
          padding: '24px'
        }}>
          {children}
        </div>
      </main>
    </div>
  );
}
